import React ,{useEffect,useState} from "react";
import { Column, DataGrid, Format, Button } from "devextreme-react/data-grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { useMsal } from "@azure/msal-react";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Container from "@material-ui/core/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../modal.css";
import { api_path } from "../../shared.js";
const url = api_path + "/GET_SALES_ORDER_DETAILS.php";
function SaleOrderMasterDetailViewForHead(props) {
  const [GET_CARRIER_CODE, SET_CARRIER_CODE] = useState(
    props.data.data.CARRIER_CODE
  );
  const [GET_SERVICES_CONTRACT, SET_SERVICES_CONTRACT] = useState(
    props.data.data.SERVICES_CONTRACT
  );
  const [GET_BULLET_CODE, SET_BULLET_CODE] = useState(
    props.data.data.BULLET_CODE
  );
  const [GET_SCAC, SET_SCAC] = useState(props.data.data.SCAC);
  const [GET_CF_FLAG, SET_CF_FLAG] = useState("1");

  const [GET_ITEM_ID, SET_ITEM_ID] = useState("");
  const [GET_BOOKING_REF, SET_BOOKING_REF] = useState("");
  const [GET_BOOKING_NO, SET_BOOKING_NO] = useState("");
  const [GET_PROFORMA_ETD, SET_PROFORMA_ETD] = useState(null);
  const [GET_ETA, SET_ETA] = useState(null);
  const [GET_BSE_NO, SET_BSE_NO] = useState(null);
  const [GET_CTNR_CUTOFF_DATE, SET_CTNR_CUTOFF_DATE] = useState(null);
  const [GET_CTNR_CUTOFF_TIME, SET_CTNR_CUTOFF_TIME] = useState(null);
  const [GET_REMARK, SET_REMARK] = useState("");
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const [GET_USER_ID, SET_USER_ID] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { instance, accounts } = useMsal();

  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          SET_USER_ID(i.CRM_UID);
        }
      });
  }
  const orderDataSource = createStore({
    key: "ORDER_ID",
    loadUrl: `${url}`,
    loadParams: { ORDER_ID: props.data.key },
  });
  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 1
      ) {
        e.cellElement.innerHTML =
        "<p style='color: GREEN;text-align:left;'>"
        +e.data.STATUS_NAME + "</p>";
      }else if (
        e.column.dataField === "STATUS_NAME" &&
        e.data.ACTIVE_STATUS == 100
      ) {
        e.cellElement.innerHTML =
        "<p style='color: GREEN;text-align:left;'>"
        +e.data.STATUS_NAME + "</p>";
      }else if (
          e.column.dataField === "STATUS_NAME" &&
          e.data.ACTIVE_STATUS > 1
        ) {
          e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>"
          +e.data.STATUS_NAME + "</p>";
        }else if (
          e.column.dataField === "STATUS_NAME" &&
          e.data.ACTIVE_STATUS == 0
        ) {
          e.cellElement.innerHTML =
          "<p style='color: RED;text-align:left;'>"
          +e.data.STATUS_NAME + "</p>";
        }else{
        
      }
    }
  }
  function updateConfirmStatus(
    ORDER_ITEM_ID,
    ORDER_ID,
    USER_ID
  ) {
    var data = {
      ORDER_ID: ORDER_ID,
      ORDER_ITEM_ID: ORDER_ITEM_ID,
      USER_ID: USER_ID,
      REMARK: GET_REMARK,
      CF_FLAG: GET_CF_FLAG,
    };
    fetch(api_path + "/SALES_ORDER_UpdateSalesOrderConfirm.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
            const url =
              api_path +
              "/SENDMAIL_SALESORDER.php?order_id=" +
              ORDER_ID +
              "&flag=updatebooking&order_status=6";
            axios
              .get(url)
              .then((response) => {
                // handle success
                console.log(result["message"]);
              })
              .then((data) => {
                console.log(data);
                // Handle data
              })
              .catch((error) => {
                // handle errors
              });
            ////////////////////////////////////////////////////
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 5000,
          });
        }
      });
  }
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random()
        * (max - min + 1)) + min;
};
  const [isCFButtonDisabled, setCFButtonDisabled] = useState(true);
  const [isUnCFButtonDisabled, setUnCFButtonDisabled] = useState(true);
  
  function onCFButtonClick(e) {
    SET_CF_FLAG(1);
    const dataRow = e.row && e.row.data;
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BOOKING_REF(dataRow.BOOKINGREF);
    SET_BSE_NO(dataRow.SMF_REFNO);
    SET_PROFORMA_ETD(dataRow.PROFORMA_ETD);
    SET_CTNR_CUTOFF_DATE(dataRow.CONTAINER_CUTOFF_DATE);
    SET_CTNR_CUTOFF_TIME(dataRow.CONTAINER_CUTOFF_TIME);
    SET_REMARK(dataRow.REMARK);
    setSelectOrderStatus(dataRow.ACTIVE_STATUS);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: dataRow.ACTIVE_STATUS,
      INQUIRY_MASTER_EN: dataRow.STATUS_NAME,
    });
    setShow(true);
  }
  function onUnCFButtonClick(e) {
    SET_CF_FLAG(0);
    const dataRow = e.row && e.row.data;
    SET_ITEM_ID(dataRow.SALES_ORDER_ITEM_ID);
    SET_BOOKING_NO(dataRow.BOOKINGNO);
    SET_BOOKING_REF(dataRow.BOOKINGREF);
    SET_BSE_NO(dataRow.SMF_REFNO);
    SET_PROFORMA_ETD(dataRow.PROFORMA_ETD);
    SET_CTNR_CUTOFF_DATE(dataRow.CONTAINER_CUTOFF_DATE);
    SET_CTNR_CUTOFF_TIME(dataRow.CONTAINER_CUTOFF_TIME);
    SET_REMARK(dataRow.REMARK);
    setSelectOrderStatus(dataRow.ACTIVE_STATUS);
    setOrderStatus({
      INQUIRY_MASTER_VALUE: dataRow.ACTIVE_STATUS,
      INQUIRY_MASTER_EN: dataRow.STATUS_NAME,
    });
    setShow(true);
  }
  const  isEdit = (BOOKINGNO) => {
    if (
      BOOKINGNO === "" ||
      BOOKINGNO === null ||
      BOOKINGNO === undefined
    ) {
      return false;
    } else {
      return true;
    }
  }
  const isCFIconVisible = (e) => isEdit(e.row.data.BOOKINGNO);
  useEffect(() => {
    fetchUserRole(accounts[0]?.username);
    if (props.data.data.ORDER_STATUS ==5 ) {
      setCFButtonDisabled(true);
    } else {
      setCFButtonDisabled(false);
    }
    if (props.data.data.ORDER_STATUS ==6 ) {
      setUnCFButtonDisabled(true);
    } else {
      setUnCFButtonDisabled(false);
    }
  }, []);

  const  customizeValue = (cellInfo) => {
    if (
      cellInfo.value === "" ||
      cellInfo.value === null ||
      cellInfo.value === undefined
    ) {
      return "-";
    } else {
      return cellInfo
    }
  }
  return (
    <>
        <DataGrid
        dataSource={orderDataSource}
        showBorders={false}
        keyExpr="ORDER_ID"
        onCellPrepared={cellPrepared}
      >
        <Column dataField="SALES_ORDER_ITEM_ID" caption="ID" visible={false} />
        <Column dataField="CARRIER_CODE" caption="CARRIER" width={100}/>
        <Column dataField="SERVICES_CONTRACT" caption="S/C" width={150}/>
        <Column dataField="BULLET_CODE" caption="BULLET CODE" width={150}/>
        <Column dataField="ACTIVE_STATUS" visible={false} />
        <Column
          dataField="STATUS_NAME"
          caption="ITEM STATUS"
          cssClass="gray"
          width={200}
        />
        <Column dataField="REMARK" caption="REMARK" cssClass="gray" />
        <Column
          dataField="BOOKINGREF"
          caption="Book Ref"
          cssClass="gray"
          width={100}
        />
        <Column
          dataField="BOOKINGNO"
          caption="Book No."
          cssClass="gray"
          width={100}
         // customizeText={customizeText}
        />
        <Column
          dataField="PROFORMA_ETD"
          caption="PROFORMA ETD"
          cssClass="gray"
          width={150}
        />
        <Column
          dataField="CONTAINER_CUTOFF_DATE"
          caption="CUTOFF DATE"
          cssClass="gray"
          width={150}
        />
        <Column
          dataField="CONTAINER_CUTOFF_TIME"
          caption="CUTOFF TIME"
          cssClass="gray"
          width={150}
        />
          <Column
          dataField="ETA"
          caption="ETA"
          cssClass="gray"
          width={150}
        />
        <Column dataField="SMF_REFNO" caption="SMF REFNO" cssClass="gray" width={100}
        />
       
      </DataGrid><br/>
     
      <label className="head3">Volume</label>
      <table border="1" width="50%">
      <tr className="box">
          <td width="80" colSpan="2" align="center">20'</td>
     
          <td width="80" colSpan="2" align="center">40'</td>
       
          <td width="80" colSpan="2" align="center">40HC</td>
        
          <td width="80" colSpan="2" align="center">45'</td>
        
          <td width="80" align="center">GW</td>
       
          <td align="center">BOOK PRIORITY</td>
       
          <td align="center">WAITING SALES TO CONFIRM</td>
        </tr>
        <tr>
        <td width="40" align="center">
           {props.data.data.CNT20== '0'? '-':props.data.data.CNT20 }
          </td>
          <td width="40" align="center">{props.data.data.TYPE20 }</td>
          <td width="40" align="center">
          {props.data.data.CNT40== '0'? '-':props.data.data.CNT40 }
          </td>
          <td width="40" align="center">{props.data.data.TYPE40 }</td>
          <td width="40" align="center">
             {props.data.data.CNT40HQ== '0'? '-':props.data.data.CNT40HQ }
          </td>
          <td width="40" align="center">{props.data.data.TYPE40HQ }</td>
          <td width="40" align="center">
          {props.data.data.CNT45== '0'? '-':props.data.data.CNT45 }
          </td>
          <td width="40" align="center">{props.data.data.TYPE45 }</td>

          <td align="center">{props.data.data.GW }</td>
        
          <td align="center">{props.data.data.BOOK_PRIORITY }</td>
          <td align="center">{props.data.data.WAITING_FLAG== 'Y'? 'YES':'NO'}</td>


        </tr>
        </table>
        <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          {GET_BOOKING_NO && GET_CF_FLAG== 1 && (
          <Modal.Title>Confirm to release booking : {GET_BOOKING_NO}</Modal.Title>
        )}
          {GET_BOOKING_NO && GET_CF_FLAG== 0 && (
          <Modal.Title>Unconfirm to release booking : {GET_BOOKING_NO}</Modal.Title>
        )}
           {!GET_BOOKING_NO && (
          <Modal.Title>Confirm to release without Booking No.</Modal.Title>
        )}
        </Modal.Header>

        <Modal.Body className="grid-example">
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateConfirmStatus(
                GET_ITEM_ID,
                props.data.key,
                GET_USER_ID
              );
            }}
            id="editmodal"
            className=""
          >
            <input
              type="hidden"
              value={GET_USER_ID}
              onChange={(e) => SET_USER_ID(e.target.value)}
            />
            <input
              type="hidden"
              value={GET_ITEM_ID}
              onChange={(e) => SET_ITEM_ID(e.target.value)}
            />
            <Container>

 
              <Row>
                <Col xs={6} md={6}> &nbsp;
                </Col>
                <Col xs={6} md={6}>
                  &nbsp;
                </Col>
                <Col xs={12} md={12}>
                  <label>
                    REMARK:
                    <TextField
                    size="small"
                    name="GET_REMARK"
                    variant="outlined"
                    fullWidth
                    id="GET_REMARK"
                    value={GET_REMARK}
                    onChange={(e) => SET_REMARK(e.target.value)}
                    multiline
                    rows={2}
                    inputProps = {{maxLength:250}}
                  />
                    {/* <input
                      type="text"
                      value={GET_REMARK}
                      onChange={(e) => SET_REMARK(e.target.value)}
                    /> */}
                  </label>
                </Col>
              </Row>
            </Container>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
      </>
    );
  }

 
function getOrderDataSource(id) {
    return {
      store: createStore({
        loadUrl: `${url}`,
        loadParams: { ORDER_ID: id },
        //   onBeforeSend: (method, ajaxOptions) => {
        //     ajaxOptions.xhrFields = { withCredentials: true };
        //   },
      }),
    };
  }
export default SaleOrderMasterDetailViewForHead;
